module.exports = __webpack_public_path__ + "img/home_our_visions_and_missions_and_goals.1efbb001.png";